<template>
  <div class="pureForm">
    <el-form :model="formInline" :rules="rules" ref="pureForm" :inline="true" label-width="60px">
      <el-form-item v-if="!removePureItem">
        <el-checkbox v-model="formInline.pureType" :true-label="1" :false-label="0" @change="handlePure">纯商品</el-checkbox>
        <el-tooltip
          class="item"
          effect="dark"
          content="纯商品铺货，目前支持淘系平台；勾选后，会使用右侧价格以及数目设置，保存后不会同步下方SKU相关属性到淘系平台资料"
          placement="top"
        >
          <i style="margin-left: 5px; margin-right: 10px" class="el-icon-question" />
        </el-tooltip>
      </el-form-item>
      <div class="pure-form">
        <el-form-item prop="purePrice" label="价格：" class="mrg-b">
          <el-input-digit
            v-model.number="formInline.purePrice"
            placeholder="请输入价格"
            :nullable="true"
            :precision="2"
            :disabled="disableInput"
            style="width: 85px"
            @change="fieldChanged"
          />
        </el-form-item>
        <el-form-item prop="num" label="库存：" class="mrg-b">
          <el-input-digit
            v-model.number="formInline.num"
            placeholder="请输入库存"
            :nullable="true"
            :precision="0"
            :disabled="(!formInline.pureType || formInline.stockType === 1) && !removePureItem"
            style="width: 85px"
            @change="fieldChanged"
          />
          <el-tooltip
            v-if="formInline.stockType > 0 && formInline.pureType && !removePureItem"
            style="line-height: 18px; padding: 0"
            popper-width="200px"
            content="供销商已开启库存同步，默认取供销商库存，如需修改需关闭开关后手动调整，修改后库存将无法自动同步供销商库存"
            placement="top"
          >
            <el-switch v-model="formInline.stockType" :active-value="1" :inactive-value="2" @change="stockTypeChange"> </el-switch>
          </el-tooltip>
        </el-form-item>
        <el-form-item prop="weight" label="重量：" class="mrg-b">
          <el-input-digit
            v-model.number="formInline.weight"
            placeholder="请输入重量"
            :nullable="true"
            :precision="4"
            :disabled="disableInput"
            style="width: 85px"
          />
        </el-form-item>
        <el-form-item prop="purchasePrice" label="成本价：" class="mrg-b">
          <el-input-digit
            v-model.number="formInline.purchasePrice"
            placeholder="请输入成本价"
            :nullable="true"
            :precision="2"
            :disabled="disableInput"
            style="width: 85px"
          />
        </el-form-item>
        <el-form-item prop="marketPrice" label="市场价：" class="mrg-b">
          <el-input-digit
            v-model.number="formInline.marketPrice"
            placeholder="请输入市场价"
            :nullable="true"
            :precision="2"
            :disabled="disableInput"
            style="width: 85px"
          />
        </el-form-item>
        <template v-if="formInline.pureType && !removePureItem">
          <el-form-item label="ERP主商家编码：" label-width="110px" class="mrg-b">
            <div>
              <span class="outid-wrapper">{{ erpOuterId || '--' }}</span>
              <i class="el-icon-copy-document" v-clipboard:copy="erpOuterId" v-clipboard:success="handleOnCopy" style="cursor: pointer" />
            </div>
          </el-form-item>
          <el-form-item label="ERP规格商家编码：" label-width="120px" class="mrg-b">
            <div>
              <span class="outid-wrapper">{{ erpSkuOuterId || '--' }}</span>
              <i
                class="el-icon-copy-document"
                v-clipboard:copy="erpSkuOuterId"
                v-clipboard:success="handleOnCopy"
                style="cursor: pointer"
              />
            </div>
          </el-form-item>
        </template>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { querySupplierStock } from '@/api/prod/center/index.js';

export default {
  name: 'pureForm',
  props: {
    pureGoods: {
      type: Object,
      default: () => {
        return {
          pureType: 0,
          purePrice: '',
          num: '',
          weight: '',
          purchasePrice: '',
          marketPrice: '',
        };
      },
    },
    // ERP主商家编码
    erpOuterId: {
      type: String || null,
    },
    // ERP规格商家编码
    erpSkuOuterId: {
      type: String || null,
    },
    // 基础商品id
    baseItemId: {
      type: String || null,
    },
  },
  data() {
    return {
      formInline: {
        pureType: 0,
        purePrice: '',
        num: '',
        weight: '',
        purchasePrice: '',
        marketPrice: '',
      },
    };
  },
  watch: {
    pureGoods: {
      handler(v) {
        this.formInline = v;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['removePureItem']),
    disableInput() {
      return !this.formInline.pureType && !this.removePureItem;
    },
    rules() {
      if (this.formInline.pureType) {
        return {
          purePrice: [{ required: true, message: '价格不能为空' }],
          num: [{ required: true, message: '库存不能为空' }],
        };
      } else {
        return {};
      }
    },
  },
  methods: {
    async stockTypeChange(v) {
      if (v === 1) {
        let res = await querySupplierStock({
          baseItemId: this.baseItemId,
        });
        if (res.result === 1 && res.data && res.data[0]) {
          this.formInline.num = res.data[0].stockNum;
        }
      }
    },
    handlePure(v) {
      if (!v) {
        this.$refs.pureForm.clearValidate();
      }
    },
    // 效验纯商品价格和库存
    validatePure() {
      return new Promise((resolve, reject) => {
        this.$refs.pureForm.validate(valid => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    clearPure() {
      this.$refs.pureForm.clearValidate();
    },

    handleOnCopy() {
      this.$message.success('复制成功');
    },
    fieldChanged() {
      this.$emit('fieldChanged');
    },
  },
};
</script>

<style lang="scss" scoped>
.pureForm {
  margin-bottom: 10px;
}
.pure-type {
  margin-left: 10px;
}
.position-pure {
  display: inline-block;
  width: 150px;
}
.tips-pure {
  color: red;
}
.mrg-b {
  margin-bottom: 25px;
}
.outid-wrapper {
  display: inline-block;
  margin-top: 10px;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  top: 8px;
}
.pure-form {
  margin-top: 10px;
  background-color: #f8f8f8;
  padding: 10px;
}
</style>